class ListService {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }

    searchProducts(term, mine) {
        let self = this;
        let isMine = mine ? 1 : 0;
        return self.$http({
            method: 'GET',
            url: `api/search/${term}/${isMine}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    }

    getAllProducts(mine) {
        let self = this;
        let isMine = mine ? 1 : 0;
        return self.$http({
            method: 'GET',
            url: `/api/product/${isMine}`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    }

    getProductsByUser() {
        let self = this;
        return self.$http({
            method: 'GET',
            url: `/api/product/user`,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    }
}

export default ListService;


// WEBPACK FOOTER //
// ./src/app/pages/lists/services/listService.js